<template>
    <div class="task-card">
        <task-card-header v-if="components.header" v-bind="{ ...headerProps }" />

        <task-card-list v-if="components.list" :tasks="tasks" />

        <task-card-achievements v-if="components.achievements" />

        <task-card-done-list v-if="components.doneList" :tasks="tasks" :icon="listType" />

        <task-card-help v-if="components.help" />

        <task-card-bottom v-if="components.footer" />
    </div>
</template>

<script setup>
import TaskCardHeader from './components/TaskCardHeader.vue'
import TaskCardList from './components/TaskCardList.vue'
import TaskCardAchievements from './components/TaskCardAchievements.vue'
import TaskCardDoneList from './components/TaskCardDoneList.vue'
import TaskCardHelp from './components/TaskCardHelp.vue'
import TaskCardBottom from './components/TaskCardBottom.vue'

defineProps({
    headerProps: {
        type: Object,
        default: () => ({}),
    },
    tasks: {
        type: Array,
        default: [],
    },
    listType: {
        type: String,
        default: 'success',
    },
    components: {
        type: Object,
        default: () => ({}),
    },
})
</script>

<style lang="scss" scoped>
.task-card {
    width: 345px;
    height: 370px;
    border-radius: 12px;
    border: 1px solid $light-grey;
}
</style>
